import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import DoneIcon from '@mui/icons-material/Done';
import { CircularProgress } from '@mui/material';

const ChatMessageItemStatus = ({ message, loading }) => {
  const status = message.temporary
    ? MESSAGE_STATUS.TEMPORARY
    : MESSAGE_STATUS.SENT;

  const iconProps = {
    sx: {
      width: 10,
      height: 10,
      mr: '2px',
    },
  };

  if (loading) {
    return <CircularProgress size={10} sx={{ mr: '2px', color: 'inherit' }} />;
  }

  const Icon = MESSAGE_STATUS_ICONS[status];

  return <Icon {...iconProps} />;
};

export default ChatMessageItemStatus;

const MESSAGE_STATUS = {
  SENT: 'sent',
  TEMPORARY: 'temporary',
};

const MESSAGE_STATUS_ICONS = {
  [MESSAGE_STATUS.SENT]: DoneIcon,
  [MESSAGE_STATUS.TEMPORARY]: QueryBuilderIcon,
};
